import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { clientPortalApi } from "./clientPortalApi";
import { useDocumentTitle } from "./useDocumentTitle";
import "./clientPortal.css";

/** Shown ONLY when a magic-link verify resolved to more than one active Client company for
 * the same email (kernel/access_resolver.find_client_contact_records()'s multi-match case,
 * per the founder's locked default: "lightweight company picker before landing on Home"). The
 * session already exists (provisionally scoped to the first match) — picking here just calls
 * /auth/switch-company to move the scope, never re-verifies the email. */
export default function ClientPortalChooseCompany() {
  useDocumentTitle("Choose Company");
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [picking, setPicking] = useState(null);

  useEffect(() => {
    clientPortalApi.me().then((r) => setCompanies(r.data.companies || [])).finally(() => setLoading(false));
  }, []);

  const choose = async (companyRemoteId) => {
    setPicking(companyRemoteId);
    try {
      await clientPortalApi.switchCompany(companyRemoteId);
      navigate("/client-portal/home", { replace: true });
    } finally {
      setPicking(null);
    }
  };

  if (loading) return <div className="cp-theme min-h-screen" />;

  return (
    <div className="cp-theme min-h-screen flex items-center justify-center px-6" data-testid="client-portal-choose-company-page">
      <div className="w-full max-w-[440px] cp-enter">
        <div className="flex justify-center mb-10"><Logo theme="dark" size="lg" /></div>
        <div className="cp-card p-8">
          <span className="cp-eyebrow">One more step</span>
          <h1 className="cp-display text-[28px] mt-2 mb-6 text-white">Which company are you signing in as?</h1>
          <div className="space-y-2">
            {companies.map((c) => (
              <button
                key={c.company_remote_id}
                onClick={() => choose(c.company_remote_id)}
                disabled={picking === c.company_remote_id}
                data-testid={`client-portal-company-option-${c.company_remote_id}`}
                className="cp-btn-secondary w-full text-left px-4 py-3.5 text-[15px] flex items-center justify-between"
              >
                {c.company_name}
                {picking === c.company_remote_id && <span className="text-xs text-[#6E6B66]">Signing in…</span>}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
